import messagesFr from "./fr.json";
export default () => ({
	messages: { fr: messagesFr },
	missingWarn: false,
	fallbackWarn: false
});
